import React from 'react';
import SectionReservationSummary from './section_reservation_summary';

const C = {
  ink: '#333333',
  sub: '#666666',
  muted: '#8B9097',
  line: '#ECECEE',
  primary: '#FF6467',
  wash: '#FFEAEA',
  surface: '#FFFFFF',
  danger: '#E05C35',
};

const SectionPlace = ({
  event,
  setEvent,
  setEventDateError,
  placeError,
  clearSelectedPlace,
  reservationSummary,
  onEditReservation,
  onCancelReservation,
}) => {
  const onEventDateError = React.useCallback(() => {
    if (!event.event_date || !event.event_end_datetime) {
      setEventDateError('イベント日時を入力してください。');
    } else {
      setEventDateError('');
    }
  }, [event]);

  return (
    <section id="place">
      <style>{`.tg-place-input::placeholder{color:#BCC1C6;opacity:1;font-weight:400;}`}</style>
      {reservationSummary && (
        <SectionReservationSummary
          summary={reservationSummary}
          onEdit={onEditReservation}
          onCancel={onCancelReservation}
        />
      )}
      <div className="container col-md-8 col-lg-6" style={{ paddingTop: 8 }}>
        <div
          style={{
            background: C.surface,
            border: `1px solid ${placeError ? C.danger : C.line}`,
            borderRadius: 16,
            padding: '14px 16px',
            boxShadow: '0 1px 2px rgba(30,30,40,.03), 0 10px 26px -16px rgba(30,30,40,.14)',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
            <span style={{ fontSize: 12, fontWeight: 800, color: C.sub, letterSpacing: '.02em' }}>場所</span>
            <span style={{ fontSize: 10, fontWeight: 800, color: C.primary, background: C.wash, borderRadius: 5, padding: '1px 6px' }}>
              必須
            </span>
          </div>
          {placeError && (
            <p style={{ color: C.danger, fontSize: 12, margin: '0 0 8px' }}>{placeError}</p>
          )}
          <input
            id="place"
            className="tg-place-input"
            value={event.place || ''}
            onChange={(e) => {
              setEvent((prev) => ({ ...prev, place: e.target.value }));
              if (e.target.value === '') {
                clearSelectedPlace();
              }
            }}
            onClick={() => onEventDateError()}
            placeholder="例）新宿駅西口"
            style={{
              width: '100%',
              border: 'none',
              outline: 'none',
              fontSize: 15,
              fontWeight: 700,
              color: C.ink,
              background: 'transparent',
              padding: 0,
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default SectionPlace;
